export default __webpack_public_path__ + "static/media/confirmation-image-ok-mark.88086c0d.svg";